<div class="bg-white rounded-circle background-template profile-pic" [ngClass]="{
  'active': activeStatus,
  'not-active': !activeStatus
}" [ngStyle]="{
  width: boxSize +'px', height: boxSize +'px'
}">
  <img *ngIf="!imageLoaded" src="assets/themes/icons/user-profile-placeholder.svg">
  <img *ngIf="imageLoaded" [src]="backgroundImg ? backgroundImg : 'assets/themes/icons/user-profile-placeholder.svg'" onerror="this.src='assets/themes/icons/user-profile-placeholder.svg'">
</div>
